import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'em-practices-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, InputTextModule, TranslatePipe],
  template: `
    <div [formGroup]="form" class="p-3">
      <div class="field">
        <label for="practiceName" class="font-medium">
          {{ 'layout.configurations.practices.addPractice.name' | translate }}
        </label>
        <input
          id="practiceName"
          type="text"
          pInputText
          formControlName="name"
          class="w-full mt-1"
          [placeholder]="'layout.configurations.practices.addPractice.name' | translate"
        />
        <small *ngIf="form.get('name')?.invalid && form.get('name')?.touched" class="p-error">
          {{ 'layout.configurations.practices.addPractice.nameIsRequired' | translate }}
        </small>
      </div>
      <div class="flex justify-content-end mt-3">
        <p-button
          [label]="'layout.configurations.practices.addPractice.save' | translate"
          (onClick)="save()"
          [disabled]="form.invalid">
        </p-button>
      </div>
    </div>
  `,
})
export class PracticesFormComponent implements OnInit {
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
  ) {}

  ngOnInit() {
    const existing = this.config.data as { id: number; name: string } | undefined;
    this.form = this.fb.group({
      name: [existing?.name ?? '', [Validators.required, Validators.minLength(1)]],
    });
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.ref.close({ name: this.form.value.name.trim() });
  }
}
